import {queryGqlApi} from "../queryGqlApi";
import { IDataClientService } from '../../platform/services/data/DataClientService';
import { IAuthService } from '../../platform/services/auth/AuthService';

export const queryQuizServerGqlApi = (
  dataClientService: IDataClientService,
  authService: IAuthService,
  query: any,
  variables: any,
  method: 'POST' | 'GET' = 'POST',
) => {
  return queryGqlApi(
    query,
    variables,
    dataClientService,
    authService,
    'pgServer',
    method
  )
}
